"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.singleSmartDates = exports.today = exports.SingleSmartDateTypeOptions = void 0;
var date_fns_1 = require("date-fns");
exports.SingleSmartDateTypeOptions = {
    yesterday: 'Yesterday',
    priorMonth: 'Prior Month',
    priorQuarter: 'Prior Quarter',
    priorYear: 'Prior Year',
};
exports.today = date_fns_1.startOfToday();
var lastCalendarDate = date_fns_1.subDays(exports.today, 1);
var singleYesterday = {
    name: exports.SingleSmartDateTypeOptions.yesterday,
    startDate: lastCalendarDate,
};
var singlePriorMonth = {
    name: exports.SingleSmartDateTypeOptions.priorMonth,
    get startDate() {
        return date_fns_1.endOfMonth(date_fns_1.subMonths(lastCalendarDate, 1));
    },
};
var singlePriorQuarter = {
    name: exports.SingleSmartDateTypeOptions.priorQuarter,
    get startDate() {
        return date_fns_1.endOfQuarter(lastCalendarDate);
    },
};
var singlePriorYear = {
    name: exports.SingleSmartDateTypeOptions.priorYear,
    get startDate() {
        return date_fns_1.endOfYear(date_fns_1.subYears(lastCalendarDate, 1));
    },
};
exports.singleSmartDates = new Map([
    [exports.SingleSmartDateTypeOptions.yesterday, singleYesterday],
    [exports.SingleSmartDateTypeOptions.priorMonth, singlePriorMonth],
    [exports.SingleSmartDateTypeOptions.priorQuarter, singlePriorQuarter],
    [exports.SingleSmartDateTypeOptions.priorYear, singlePriorYear],
]);
